var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic-line"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CF3819",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.4239 29.839L33.1915 34.6066L34.6058 33.1924L14.8068 13.3934L13.3926 14.8076L18.9992 20.4142V22C18.9992 24.7614 21.2378 27 23.9992 27C24.4815 27 24.9479 26.9317 25.3892 26.8042L26.9394 28.3544C26.0454 28.7688 25.0493 29 23.9992 29C20.4727 29 17.5553 26.3923 17.0701 23H15.0541C15.5153 27.1716 18.8276 30.4839 22.9992 30.9451V35H24.9992V30.9451C26.2331 30.8087 27.3919 30.4228 28.4239 29.839ZM23.5518 24.9669C22.2531 24.7727 21.2265 23.7461 21.0323 22.4473L23.5518 24.9669ZM31.3737 27.1604L29.9313 25.7179C30.4397 24.9084 30.787 23.9874 30.9283 23H32.9442C32.7744 24.5366 32.2177 25.9565 31.3737 27.1604ZM28.4648 24.2514L26.9163 22.703C26.9705 22.4775 26.9992 22.2421 26.9992 22V18C26.9992 16.3432 25.656 15 23.9992 15C22.7049 15 21.6021 15.8196 21.1814 16.968L19.6848 15.4714C20.5533 13.9927 22.1603 13 23.9992 13C26.7606 13 28.9992 15.2386 28.9992 18V22C28.9992 22.8099 28.8066 23.5748 28.4648 24.2514Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOffIcon);
export default __webpack_public_path__ + "static/media/micOffIcon.5ac8bae5b7545e693d6afe9f2ec33586.svg";
export { ForwardRef as ReactComponent };